import FormCheckbox from './FormCheckbox'

export default FormCheckbox



// WEBPACK FOOTER //
// ./src/components/Form/Checkbox/index.js